import React from "react";
import MenuProducto from "../productos/navProductos";
import { Outlet } from "react-router-dom";

const LayoutProductos = () => {
    return (
        <>
            <MenuProducto />
            <div className="contenido">
                <Outlet />
            </div>
        </>
    );
};

export default LayoutProductos;